

























import { Component, Vue } from 'vue-property-decorator'
import { Icon, Menu } from 'ant-design-vue'

@Component({
  name: 'Nav',
  components: {
    'a-menu': Menu,
    'a-menu-item': Menu.Item,
    'a-icon': Icon
  }
})
export default class Nav extends Vue {
  current: string[] = [this.$route.name as string]
}
